// postMessage protocol between editor.bizzey.com (the iframe, see
// Application.tsx) and whatever host page embeds it (see
// widget/tourBuilder/EmbeddedEditorFrame.tsx). Kept in its own module so
// both sides - which live in separate webpack bundles - share one contract.

export const EDITOR_MESSAGE_SOURCE = 'bizzey-embeddable-editor' as const
export const HOST_MESSAGE_SOURCE = 'bizzey-embeddable-editor-host' as const

// Sent by the iframe.
export type EditorToHostMessage =
  | { source: typeof EDITOR_MESSAGE_SOURCE, type: 'ready' }
  | { source: typeof EDITOR_MESSAGE_SOURCE, type: 'change', html: string }

// Sent by the host.
export type HostToEditorMessage =
  { source: typeof HOST_MESSAGE_SOURCE, type: 'setContent', html: string }
